export const environment = {
  production: true,
  adminApiUrl: 'https://portal.indychamber.com/api/admin/',
  portalApiUrl: 'https://portal.indychamber.com/api/public/',
  loginTokenUrl: 'https://portal.indychamber.com/authentication/login/'
};
